import { useEffect, useState } from 'react'
import { alsDauer, api } from '../../api/client'
import type { Wochenzeile } from './typen'

const TAGE = ['Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa', 'So']

function montagVon(datum: string): Date {
  const d = new Date(datum + 'T12:00:00')
  const versatz = (d.getDay() + 6) % 7 // Sonntag ist 0, wir wollen Montag als Wochenanfang
  d.setDate(d.getDate() - versatz)
  return d
}

/** Auslastung je Fahrer über die Woche — zeigt freie Tage und Überlastung auf einen Blick. */
export function Wochenplan({ datum }: { datum: string }) {
  const [zeilen, setZeilen] = useState<Wochenzeile[]>([])
  const [laedt, setLaedt] = useState(true)

  useEffect(() => {
    setLaedt(true)
    api
      .get<Wochenzeile[]>(`/api/disposition/wochenplan?datum=${datum}`)
      .then(setZeilen)
      .finally(() => setLaedt(false))
  }, [datum])

  const montag = montagVon(datum)
  const tagesdaten = TAGE.map((_, i) => {
    const d = new Date(montag)
    d.setDate(d.getDate() + i)
    return d.toISOString().slice(0, 10)
  })

  return (
    <div className="karte abschnitt">
      <h2>
        Woche ab {montag.toLocaleDateString('de-DE')}
        <span style={{ fontWeight: 400, color: 'var(--grau-500)', marginLeft: 10, fontSize: '0.88rem' }}>
          Auslastung je Mitarbeiter
        </span>
      </h2>

      {laedt ? (
        <div className="laden">Wird geladen …</div>
      ) : (
        <div className="tabelle-huelle" style={{ boxShadow: 'none' }}>
          <table>
            <thead>
              <tr>
                <th>Mitarbeiter</th>
                <th>Team</th>
                {TAGE.map((t, i) => (
                  <th key={t} style={{ textAlign: 'center', width: 62 }}>
                    {t}
                    <div style={{ fontWeight: 400, fontSize: '0.68rem', color: 'var(--grau-500)' }}>
                      {tagesdaten[i].slice(8, 10)}.{tagesdaten[i].slice(5, 7)}.
                    </div>
                  </th>
                ))}
                <th style={{ textAlign: 'right' }}>Summe</th>
              </tr>
            </thead>
            <tbody>
              {zeilen.map((z) => {
                const ueber = z.vertraglich !== null && z.arbeitszeitGesamt > z.vertraglich
                return (
                  <tr key={z.fahrerId}>
                    <td>
                      <strong>{z.fahrerName}</strong>
                    </td>
                    <td style={{ color: 'var(--grau-500)', fontSize: '0.83rem' }}>
                      {z.teamName ?? '—'}
                    </td>
                    {tagesdaten.map((tag) => {
                      const eintrag = z.kurseJeTag[tag]
                      return (
                        <td key={tag} style={{ textAlign: 'center', padding: '6px 4px' }}>
                          {eintrag === undefined ? (
                            <span style={{ color: 'var(--grau-300)' }}>·</span>
                          ) : eintrag === 'abwesend' ? (
                            <span
                              className="etikett orange"
                              style={{ fontSize: '0.68rem', padding: '2px 6px' }}
                            >
                              frei
                            </span>
                          ) : (
                            <span
                              className="etikett navy"
                              style={{ fontSize: '0.72rem', padding: '2px 7px' }}
                            >
                              {eintrag}
                            </span>
                          )}
                        </td>
                      )
                    })}
                    <td className="zahl" style={{ textAlign: 'right' }}>
                      <span className={ueber ? 'etikett rot' : undefined}>
                        {alsDauer(z.arbeitszeitGesamt)}
                      </span>
                      {z.vertraglich !== null && (
                        <div style={{ color: 'var(--grau-500)', fontSize: '0.72rem' }}>
                          von {alsDauer(z.vertraglich)}
                        </div>
                      )}
                    </td>
                  </tr>
                )
              })}
            </tbody>
          </table>
        </div>
      )}

      <div className="legende">
        <span>
          <i style={{ background: 'var(--navy-700)' }} /> Kursnummer = eingeteilt
        </span>
        <span>
          <i style={{ background: 'var(--orange-500)' }} /> frei = Abwesenheit
        </span>
        <span>
          <i style={{ background: 'var(--grau-300)' }} /> Punkt = nicht eingeteilt
        </span>
      </div>
    </div>
  )
}
